(ns ballot-scout-v2-frontend.components.icon)

(defn icon
  "Component for a font-awesome icon."
  [icon-k & [{:keys [type spin? pulse? class]
              :or {type ::solid spin? false pulse? false}}]]
  (let [icon-cls (str "fa-" (name icon-k))
        type-cls ({::solid "fas"
                   ::regular "far"
                   ::light "fal"} type)]
    [:i {:class (str icon-cls " " type-cls
                     (when spin? " fa-spin")
                     (when pulse? " fa-pulse")
                     (when class (str " " class)))}]))
